import StatusBadge from '@/components/base/StatusBadge';
import HotRankList from './HotRankList';
import type { GossipEvent } from '@/types/gossip';

interface HeroSectionProps {
  event: GossipEvent;
}

export default function HeroSection({ event }: HeroSectionProps) {
  return (
    <section id="top" className="w-full px-4 md:px-6 py-8 md:py-12">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        <div className="lg:col-span-2">
          <div className="relative w-full h-[420px] md:h-[540px] rounded-lg overflow-hidden">
            <img
              src={event.cover}
              alt={`${event.title} 事件配图`}
              title={`${event.title} 瓜圈速报`}
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/45 to-foreground-950/10"></div>

            <div className="absolute top-4 left-4 md:top-5 md:left-5 flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold font-label text-foreground-950">
                <i className="ri-fire-fill"></i>
                今日大瓜
              </span>
              <StatusBadge status={event.status} />
            </div>

            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex flex-wrap items-center gap-2 mb-3">
                <span className="rounded-md bg-background-50/15 backdrop-blur-sm px-2.5 py-1 text-xs font-label text-background-100">
                  #{event.category}
                </span>
                {event.tags.slice(0, 2).map((tag) => (
                  <span key={tag} className="rounded-md bg-background-50/10 backdrop-blur-sm px-2.5 py-1 text-xs font-label text-background-200">
                    #{tag}
                  </span>
                ))}
              </div>

              <h1 className="font-heading text-2xl md:text-4xl text-background-50 leading-snug max-w-2xl">
                {event.title}
              </h1>

              <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl line-clamp-2">
                {event.summary}
              </p>

              <div className="mt-4 flex items-center gap-3 rounded-md bg-foreground-950/50 backdrop-blur-sm border border-background-50/10 px-3.5 py-3 max-w-2xl">
                <span className="shrink-0 w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                  <i className="ri-flashlight-line text-background-50 dark:text-foreground-950"></i>
                </span>
                <div className="min-w-0">
                  <p className="text-[11px] text-accent-400 font-label">{event.latestTime} · 最新进展</p>
                  <p className="text-sm text-background-100 truncate">{event.latestText}</p>
                </div>
              </div>

              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href={`#${event.id}`}
                  className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看完整跟进时间线
                  <i className="ri-arrow-right-line"></i>
                </a>
                <span className="text-xs text-background-300 flex items-center gap-1.5">
                  <i className="ri-refresh-line"></i>
                  已更新 {event.updateCount} 次
                </span>
              </div>
            </div>
          </div>
        </div>

        <div id="hot" className="lg:col-span-1 scroll-mt-24">
          <HotRankList />
        </div>
      </div>
    </section>
  );
}